function uniqid() {

    var ts=String(new Date().getTime()), i = 0, out = '';
    for(i=0;i<ts.length;i+=2) {
        out+=Number(ts.substr(i, 4)).toString(36);
    }
    return String(new Date().getTime())+('d'+out)+Math.round(Math.random())*11;
}

if (!Date.now) {
    Date.now = function() { return new Date().getTime(); }
}

function timeConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var sec = a.getSeconds();
    var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    return time;
}

function array_unique(list) {
    var result = [];
    $.each(list, function(i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}

function inArray(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
}

function isFunction(functionName) {
    return typeof(functionName) === typeof(Function);
}

/**
 * Controlla che il dispositivo sia in portrait
 */
function isPortrait() {
    return window.innerHeight > window.innerWidth;
}

/**
 * Controlla che il dispositivo sia in landscape
 */
function isLandscape() {
    return (window.orientation === 90 || window.orientation === -90);
}

jQuery.fn.outerHTML = function() {
    return jQuery('<div />').append(this.eq(0).clone()).html();
};

function removeFirstCharIf(string, char) {

    if( string.charAt( 0 ) === char ) {
        string = string.slice( 1 );
    }
    return string;
}